import { Pill } from '@mantine/core';
import { clsx } from 'clsx';

import classes from './tag-theme.module.css';
import { shouldUseWhiteText } from '../../utils/color';

import type { TagSystemProps } from './tag-types';

export const TagSystem = (props: TagSystemProps) => {
  const {
    color,
    children,
    size = 'standard',
    className,
    'data-testid': dataTestId,
    withRemoveButton,
    onRemove,
    removeAriaLabel,
    onClick,
  } = props;

  const removeButtonProps = removeAriaLabel ? { 'aria-label': removeAriaLabel } : undefined;

  if (color.startsWith('#')) {
    const textColor = shouldUseWhiteText(color) ? '#ffffff' : '#000000';
    return (
      <Pill
        className={clsx(classes.root, classes.solid, classes[size], className)}
        classNames={{ label: classes.label }}
        data-testid={dataTestId}
        onClick={onClick}
        onRemove={onRemove}
        removeButtonProps={removeButtonProps}
        style={{ background: color, '--tag-text-color': textColor } as React.CSSProperties}
        withRemoveButton={withRemoveButton}
      >
        {children}
      </Pill>
    );
  }

  const variant = 'variant' in props ? (props.variant ?? 'solid') : 'solid';
  const shouldShowDot = 'shouldShowDot' in props ? (props.shouldShowDot ?? true) : true;
  const isOutline = variant === 'outline';

  return (
    <Pill
      className={clsx(classes.root, classes[color], classes[variant], classes[size], className)}
      classNames={{ label: classes.label }}
      data-testid={dataTestId}
      onClick={onClick}
      onRemove={onRemove}
      removeButtonProps={removeButtonProps}
      withRemoveButton={withRemoveButton}
    >
      {isOutline && shouldShowDot && <span className={classes.dot} />}
      {children}
    </Pill>
  );
};
